import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import FlagCircleRoundedIcon from '@mui/icons-material/FlagCircleRounded';
import TabularViewofFlagList, { FlagType } from "./TabularViewofFlagList";

type TabularView = {
  tabularViewData: any,
  flags?: FlagType[]
}


const TabularViewTraclist = ({ tabularViewData, flags }: TabularView) => {
  let serialNo = 0;
  const [isFlag, setIsFlag] = useState(false);
  return (
    <>
      <div className="whiteBox tabularTbale">
        <div className="old_dashboard_title  flex  gap-3">
          <h1 className="text-2xl font-bold text-gray-700 mt-[-15px] mb-[10px]">List of Events</h1>
          {
            flags && flags?.length >= 1 && (

              <button className="mt-[-15px] mb-[10px]" onClick={() => setIsFlag(prev => !prev)}>
                {/* <Badge badgeContent={flags?.length} color="error"> */}
                <FlagCircleRoundedIcon />
                {/* </Badge> */}
              </button>
            )
          }
        </div>

        {
          isFlag ? (
            <TabularViewofFlagList flags={flags} />
          ) :
            (
              <>
                <div className="listEventsTableResponsiive ">
                  <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>Sno</TableCell>
                          <TableCell>Milestone Type</TableCell>
                          <TableCell>Updates</TableCell>
                          <TableCell>Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody >
                        {(tabularViewData?.first || []).map((row: any, index: number) => {
                          const id = index + 1;
                          serialNo++;
                          return (

                            <TableRow key={id}>
                              <TableCell>{serialNo}</TableCell>
                              <TableCell>{row?.milestoneType}</TableCell>
                              <TableCell>{row.name}</TableCell>
                              <TableCell>{row?.date}</TableCell>
                            </TableRow>
                          );
                        })}
                        {(tabularViewData?.events || []).map((row: any, index: number) => {
                          const id = index + 1;
                          serialNo++;
                          return (
                            <>
                              <TableRow key={id}>
                                <TableCell sx={{ backgroundColor: "#f9f9f9" }}>
                                  {serialNo}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#f9f9f9" }}>
                                  {row?.milestoneType}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#f9f9f9" }}>
                                  {row?.milestone === "Pending"
                                    ? `${row?.awbNumber} ${row?.milestone} in Airline Portal`
                                    : row?.milestone === "Active"
                                      ? `${row?.awbNumber} ${row?.milestone} in Airline Portal`
                                      : row?.milestone === "Delivered"
                                        ? `${row?.milestone} at ${row?.destination}, ${row?.pieces} Pkts`
                                        : row?.milestone === "Gate In"
                                          ? `${row?.milestone} at ${row?.origin}`
                                          : row?.milestone?.includes("Departure")
                                            ? `${row?.milestone} from ${row?.origin}, ${row?.pieces} Pkts, flight ${row?.flightNumber}`
                                            : row?.milestone?.includes("Schedule Change")
                                              ? `${row?.milestone}, ${row?.flightNumber} ${row?.origin
                                              }-${row?.destination} (NEW ETD: ${row?.eta || ""
                                              }, NEW ETA: ${row?.etd || ""})`
                                              : `${row?.milestone} at ${row?.destination}, ${row?.pieces} Pkts, flight ${row?.flightNumber}`}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#f9f9f9" }}>
                                  {row?.date}
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                        {(tabularViewData?.last || []).map((row: any, index: number) => {
                          const id = index + 1;
                          serialNo++;
                          return (
                            <>
                              <TableRow key={id}>
                                <TableCell sx={{ backgroundColor: "#f9f9f9" }}>
                                  {serialNo}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#f9f9f9" }}>
                                  {row?.milestoneType}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#f9f9f9" }}>
                                  {row.name}
                                </TableCell>
                                <TableCell sx={{ backgroundColor: "#f9f9f9" }}>
                                  {row?.date}
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </>
            )
        }
      </div>
    </>
  );
};

export default TabularViewTraclist;
